<div class="tw-gap-3 tw-flex tw-flex-col">
  <div
    class="tw-flex tw-items-center tw-rounded-2xl tw-gap-3 tw-p-4 tw-bg-white/40 dark:tw-bg-white/[0.06]"
  >
    @if (coupon().logoSvg) {
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-bg-white tw-rounded-xl tw-flex-shrink-0"
      >
        <svg class="tw-w-[70%] tw-h-[70%]">
          <use [attr.xlink:href]="'images/sprite.svg#' + coupon().logoSvg"></use>
        </svg>
      </div>
    }

    <div class="tw-flex tw-flex-col tw-gap-1 tw-flex-1">
      <span class="tw-font-semibold tw-text-base tw-text-color-text-default">{{
        coupon().attribute
      }}</span>
      @if (displayCopy()) {
        <span class="tw-text-sm tw-text-color-text-tertiary tw-leading-tight">{{
          displayCopy()
        }}</span>
      }
    </div>
  </div>

  <div
    class="tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-p-4 tw-bg-white/40 dark:tw-bg-white/[0.06]"
  >
    <span class="tw-text-[15px] tw-font-semibold tw-text-color-text-action tw-text-center">
      {{ coupon().offerOnPopup }}
    </span>

    @if (coupon().promoVoucher) {
      <div class="tw-flex tw-flex-col tw-gap-2">
        <div
          class="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-12 tw-rounded-xl tw-px-4 tw-bg-color-surface-sunken"
        >
          <span
            class="tw-font-D-DIN-PRO tw-text-color-text-default tw-tracking-wider tw-text-[16px]"
          >
            {{ coupon().promoVoucher }}
          </span>
          <button
            type="button"
            (click)="copyToClipboard(coupon().promoVoucher!)"
            [attr.aria-label]="(isCopied ? 'copied' : 'copyCode') | i18n"
            class="tw-flex tw-items-center tw-justify-center tw-text-color-text-secondary hover:tw-text-color-text-action tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-1"
          >
            <icon [name]="isCopied ? 'copied' : 'copy-06'" [size]="5"></icon>
          </button>
        </div>
        <span class="tw-text-[12px] tw-text-color-text-tertiary tw-text-center">
          {{ "tapToCopyCodeSavedCaption" | i18n }}
        </span>
      </div>
    }
  </div>

  @if (coupon().termsAndConditions && coupon().termsAndConditions!.length > 0) {
    <div
      class="tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-p-4 tw-bg-white/40 dark:tw-bg-white/[0.06]"
    >
      <span class="tw-text-sm tw-font-semibold tw-text-color-text-default">
        {{ "termsAndConditions" | i18n }}
      </span>
      <ul
        class="tw-flex tw-flex-col tw-gap-1 tw-pl-4 tw-text-[12px] tw-font-medium tw-leading-[150%] tw-tracking-normal tw-text-color-text-tertiary tw-list-disc"
      >
        @for (term of coupon().termsAndConditions; track $index) {
          <li>{{ term }}</li>
        }
      </ul>
    </div>
  }

  @if (coupon().category) {
    <div class="tw-text-center">
      <span class="tw-text-[10px] tw-text-color-text-disabled"
        >Category: {{ coupon().category }}</span
      >
    </div>
  }

  @if (coupon().url && !coupon().uniqueTrackingLink?.length) {
    <button
      type="button"
      (click)="onRedeem(coupon().url)"
      [style.background]="glassButtonBg"
      [style.box-shadow]="glassButtonShadow"
      class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-h-[56px] tw-px-8 tw-py-3 tw-rounded-2xl tw-border-[1.5px] tw-border-white/60 dark:tw-border-white/[0.18] tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-tracking-[0.005em] tw-text-color-text-on-action"
    >
      {{ coupon().buttontext || ("visitWebsite" | i18n) }}
    </button>
  }

  @if (coupon().uniqueTrackingLink && coupon().uniqueTrackingLink!.length > 0) {
    @for (link of coupon().uniqueTrackingLink; track $index) {
      <div class="tw-flex tw-flex-col tw-gap-1">
        @if (coupon().uniqueTrackingLabels && coupon().uniqueTrackingLabels!.length > 0) {
          <span class="tw-text-sm tw-font-bold tw-text-color-text-secondary tw-text-center">
            {{ coupon().uniqueTrackingLabels?.[$index] }}
          </span>
        }
        <button
          type="button"
          (click)="onRedeem(link)"
          [style.background]="glassButtonBg"
          [style.box-shadow]="glassButtonShadow"
          class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-h-[56px] tw-px-8 tw-py-3 tw-rounded-2xl tw-border-[1.5px] tw-border-white/60 dark:tw-border-white/[0.18] tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-tracking-[0.005em] tw-text-color-text-on-action"
        >
          {{ coupon().buttontext || ("visitWebsite" | i18n) }}
        </button>
      </div>
    }
  }
</div>
